import React, { Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { Button, Card, Col, Form, Input, InputNumber, message, Row, Select } from 'antd';
import moment from 'moment';

import { queryBudgetExpend } from '@api/finance/finance';
import {
  queryAdjustable,
  queryAdjustmentInfo,
  queryAdjustmentWorkflow,
  queryDeleteAdjustment,
  querySaveAdjustment,
} from '@api/finance/budget';
import util from '@util/index';

import { BackBtn } from '@comm/BackBtn';
import Process from '@comm/workflow/Process';
import ProcessHistory from '@comm/workflow/ProcessHistory';
import DescriptionList from '@comm/DescriptionList';

const FormItem = Form.Item;
const { Option } = Select;
const { Description } = DescriptionList;

class BaseForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      content: [{ id: new Date().getTime() }],
      data: {},
      instance: {},
      isInitiate: true,
      expendType: [],
      monthList: [],
      adjustList: [],
      adjustInit: 0,
      year: '',
    };
  }

  componentWillMount() {}

  componentDidMount() {
    this.setData();

    // 设置支出类别
    queryBudgetExpend().then(res => {
      if (res.statusCode === 200) {
        this.setState({
          expendType: res.data,
        });
      }
    });

    // 设置月份数组
    const monthList = [
      { key: '一月', value: '01', disFlag: false },
      { key: '二月', value: '02', disFlag: false },
      { key: '三月', value: '03', disFlag: false },
      { key: '四月', value: '04', disFlag: false },
      { key: '五月', value: '05', disFlag: false },
      { key: '六月', value: '06', disFlag: false },
      { key: '七月', value: '07', disFlag: false },
      { key: '八月', value: '08', disFlag: false },
      { key: '九月', value: '09', disFlag: false },
      { key: '十月', value: '10', disFlag: false },
      { key: '十一月', value: '11', disFlag: false },
      { key: '十二月', value: '12', disFlag: false },
    ];

    // 设置调整类型
    const adjustList = [
      { key: '增加', value: 1 },
      { key: '减少', value: 0 },
    ];

    // 设置可调整月份
    const { year } = this.props.params;
    const currentYear = moment.unix(new Date().getTime() / 1000).format('YYYY');
    const currentMonth = moment.unix(new Date().getTime() / 1000).format('MM');

    if (currentYear === year) {
      monthList.map(item => {
        if (item.value < currentMonth) {
          item.disFlag = true;
        }
        return 1;
      });
    } else if (year < currentYear) {
      monthList.map(item => {
        item.disFlag = true;
        return 1;
      });
    }

    this.setState(() => {
      return {
        monthList,
        adjustList,
      };
    });
  }

  // 获取调整组数据
  setData = () => {
    const { uuid } = this.props.params;
    const instance = {};

    // 判断是发起还是编辑

    if (uuid !== 'initiate') {
      // 编辑
      queryAdjustmentInfo({
        uuid,
      }).then(res => {
        if (res.statusCode === 200) {
          res.data.init = res.data.budget;
          res.data.wfUuid = res.data.uuid;
          res.data.details.map(item => {
            item.id = item.uuid;
            return 1;
          });

          this.setState(
            {
              data: res.data,
              content: res.data.details,
              isInitiate: false,
              year: res.data.year,
            },
            () => {
              this.setSumInit();
            },
          );
        }
      });
    } else {
      // 发起
      const { adjust_data: adjustData } = this.props;
      adjustData.groupUuid = adjustData.uuid;
      adjustData.groupName = adjustData.name;

      this.setState({
        data: adjustData,
        isInitiate: true,
        year: this.props.params.year,
      });
    }

    // 发起的流程跟踪
    queryAdjustmentWorkflow().then(res => {
      if (res.statusCode === 200) {
        this.setState(() => {
          instance.activities = res.data;
          return {
            instance,
          };
        });
      }
    });
  };

  // 获取可调整金额
  getAdjustable = (id, params) => {
    const { content } = this.state;
    queryAdjustable(params).then(res => {
      if (res.statusCode === 200) {
        content.map(item => {
          if (item.id === id) {
            item.adjustable = res.data.adjustable;
          }

          return 1;
        });
        this.setState({
          content,
        });
      }
    });
  };

  // 费用类型改变
  changeExpendType = (id, e) => {
    const month = this.props.form.getFieldValue(`month${id}`);
    month &&
      this.getAdjustable(id, {
        groupUuid: this.state.data.groupUuid,
        type: e,
        yearMonth: `${this.props.params.year}-${month}`,
      });
    return e;
  };

  // 根据月份得到可调整金额
  changeMonth = (id, e) => {
    const params = {};
    const type = this.props.form.getFieldValue(`expendType${id}`);
    params.groupUuid = this.state.data.groupUuid;
    params.type = type;
    params.yearMonth = `${this.props.params.year}-${e}`;
    this.getAdjustable(id, params);
    return e;
  };

  // 预算类型（增加或减少）改变
  changeAdjustType = (id, e) => {
    this.setSumInit(id, 'type', e);
    return e;
  };

  // 预算调整金额改变
  changeMoney = (id, e) => {
    this.setSumInit(id, 'money', e);

    // 编辑情况下 避免可调整金额缺失
    const { isInitiate } = this.state;
    const month = this.props.form.getFieldValue(`month${id}`);
    const type = this.props.form.getFieldValue(`expendType${id}`);
    !isInitiate &&
      this.getAdjustable(id, {
        groupUuid: this.state.data.groupUuid,
        type,
        yearMonth: `${this.props.params.year}-${month}`,
      });
    return e;
  };

  // 生成调整后的总额
  setSumInit = (id, it, e) => {
    const { content } = this.state;
    let adjustInit = 0;
    const values = this.props.form.getFieldsValue();
    content.map(item => {
      (item.target || item.target === 0) && (item.target = +values[`adjustType${item.id}`]);
      let adjustment = +values[`money${item.id}`];

      if (item.id === id) {
        if (it === 'money') {
          adjustment = +e;
        } else if (it === 'type') {
          item.target = +e;
        }
      }

      if (item.target === 0) {
        adjustment && (adjustInit -= adjustment);
      } else if (item.target === 1) {
        adjustment && (adjustInit += adjustment);
      }

      return 1;
    });

    this.setState({
      adjustInit,
      content,
    });
  };

  // 提交
  submit = e => {
    const { data, content } = this.state;
    const params = {};

    if (e) {
      e.preventDefault();
    }

    // 整理details数据
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const newContent = JSON.parse(JSON.stringify(content));
        newContent.map(item => {
          item.type = values[`expendType${item.id}`];
          item.month = values[`month${item.id}`];
          item.target = +values[`adjustType${item.id}`];
          item.adjustment = +values[`money${item.id}`];
          item.reason = values[`reson${item.id}`];
          delete item.adjustable;
          delete item.id;
          return item;
        });

        // 设置params数据
        data.wfUuid && (params.uuid = data.wfUuid);
        params.groupUuid = data.groupUuid;
        params.groupName = data.groupName;
        params.year = this.props.params.year;
        params.details = newContent;

        querySaveAdjustment(params).then(res => {
          if (res.statusCode === 200) {
            message.success(`${res.message}`, 2.5);
            this.props.router.push({
              pathname: `/finance/budget/adjust_manage_mine`,
            });
          } else {
            message.error(`${res.message}`, 2.5);
          }
        });
      }
    });
  };

  // 删除申请
  handleDelete = () => {
    const { data } = this.state;
    queryDeleteAdjustment({
      uuid: data.wfUuid,
    }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message, 2.5);
      }
    });

    browserHistory.go(-1);
  };

  // 明细新增
  handleAdd = () => {
    const { content } = this.state;
    content.push({ id: new Date().getTime() });
    this.setState({
      content,
    });
  };

  // 明细删除
  handleSub = index => {
    const { content } = this.state;
    content.splice(index, 1);
    this.setState({
      content,
    });
    this.setSumInit();
  };

  // 明细调整组件
  adjustItem = (item, index) => {
    const { getFieldDecorator } = this.props.form;
    const { content, expendType, monthList, adjustList } = this.state;
    return item ? (
      <Row gutter={25} key={item.id}>
        <Col span={4}>
          <FormItem>
            {getFieldDecorator(`expendType${item.id}`, {
              rules: [{ required: true, message: '请选择费用科目' }],
              getValueFromEvent: e => this.changeExpendType(item.id, e),
              initialValue: item.type,
            })(
              <Select placeholder="请选择费用科目" showSearch>
                {expendType.map(item1 => {
                  return <Option key={item1.value}>{item1.key}</Option>;
                })}
              </Select>,
            )}
          </FormItem>
        </Col>
        <Col span={4}>
          <FormItem>
            {getFieldDecorator(`month${item.id}`, {
              rules: [{ required: true, message: '请选择科目月份' }],
              getValueFromEvent: e => this.changeMonth(item.id, e),
              initialValue: item.month,
            })(
              <Select placeholder="请选择科目月份" showSearch>
                {monthList.map(item1 => {
                  return <Option key={item1.value}>{item1.key}</Option>;
                })}
              </Select>,
            )}
          </FormItem>
        </Col>
        <Col span={4}>
          <FormItem>
            {getFieldDecorator(`adjustType${item.id}`, {
              rules: [{ required: true, message: '请选择调整类型' }],
              getValueFromEvent: e => this.changeAdjustType(item.id, e),
              initialValue: item.target || item.target === 0 ? `${item.target}` : null,
            })(
              <Select placeholder="请选择调整类型" showSearch>
                {adjustList.map(item1 => {
                  return <Option key={item1.value}>{item1.key}</Option>;
                })}
              </Select>,
            )}
          </FormItem>
        </Col>
        <Col span={4}>
          <FormItem>
            {getFieldDecorator(`money${item.id}`, {
              rules: [{ required: true, message: '填写调整金额' }],
              getValueFromEvent: e => this.changeMoney(item.id, e),
              initialValue: item.adjustment,
            })(
              <InputNumber
                placeholder={
                  item.target === 0 && (item.adjustable || item.adjustable === 0)
                    ? `可调整预算${item.adjustable}元`
                    : '请填写调整金额'
                }
                min={0}
                max={
                  item.target === 0 && (item.adjustable || item.adjustable === 0)
                    ? item.adjustable
                    : Infinity
                }
                style={{ width: '100%' }}
              />,
            )}
          </FormItem>
        </Col>
        <Col span={4}>
          <FormItem>
            {getFieldDecorator(`reson${item.id}`, {
              rules: [{ required: true, message: '填写调整原因' }],
              initialValue: item.reason,
            })(<Input placeholder="请填写调整原因" />)}
          </FormItem>
        </Col>
        <Col span={4}>
          <FormItem>
            {content.length < 2 ? null : (
              <Button onClick={() => this.handleSub(index)}>删除</Button>
            )}
          </FormItem>
        </Col>
        <Col span={24}>
          {index === content.length - 1 ? (
            <Button onClick={this.handleAdd} style={{ borderStyle: 'dashed', width: '89%' }}>
              +新增
            </Button>
          ) : null}
        </Col>
      </Row>
    ) : null;
  };

  render() {
    const { content, data, isInitiate, adjustInit, instance, year } = this.state;
    return (
      <Form>
        <div style={{ height: '50px' }}>
          <BackBtn />
          <Button ghost className="btnn" onClick={this.submit}>
            提交
          </Button>
          {isInitiate ? null : (
            <Button className="btnn" onClick={this.handleDelete} ghost>
              删除
            </Button>
          )}
        </div>

        <Card title="预算信息">
          <DescriptionList size="large" col={3}>
            <Description term="预算组">{data.groupName}</Description>
            <Description term="预算总额">
              <span>
                {util.numberFormat(+data.init)}
                {adjustInit && (data.init || data.init === 0) ? (
                  <span style={{ color: 'red' }}>
                    <span style={{ color: '#505659' }}>{'( '}</span>
                    调整后：
                    {util.numberFormat(adjustInit + +data.init)}
                    <span style={{ color: '#505659' }}>{' )'}</span>
                  </span>
                ) : (
                  ''
                )}
              </span>
            </Description>
            <Description term="目标收入">{util.numberFormat(+data.aims)}</Description>
            <Description term="预算年度">{year}</Description>
            <Description term="预算余额">
              <span>
                {util.numberFormat(+data.current)}
                {data.freeze ? (
                  <span style={{ color: '#BCBCBC' }}>
                    <span style={{ color: '#505659' }}>{'( '}</span>
                    冻结
                    {util.numberFormat(+data.freeze)}
                    <span style={{ color: '#505659' }}>{' )'}</span>
                  </span>
                ) : (
                  ''
                )}
              </span>
            </Description>
            <Description term="实际收入">{util.numberFormat(+data.income)}</Description>
          </DescriptionList>

          <div style={{ textAlign: 'center', padding: '30px 0' }}>预算调整明细</div>
          {content.map((item, index) => this.adjustItem(item, index))}
        </Card>

        <Card title="流程跟踪">
          <Row justify="center">
            <Col span={24} style={{ marginBottom: '16px', fontSize: '14px' }}>
              <div style={{ marginBottom: '16px', fontSize: '14px' }}>流程路径：</div>
              <Process instance={instance} />
            </Col>
            <Col span={24}>
              {isInitiate ? null : <ProcessHistory dataSource={data.histories} />}
            </Col>
          </Row>
        </Card>
      </Form>
    );
  }
}

export default connect(state => ({
  adjust_data: state.adjust_data,
}))(Form.create({ wrappedComponentRef: true })(BaseForm));



// WEBPACK FOOTER //
// ./src/components/finance/budget/adjust/PageAdd.js